module.exports = __webpack_public_path__ + "static/media/coi.8893af82.svg";